<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technician" title="Works" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="row mb-3">
                                <div class="col-md-10">
									<div class="mm-cart-text">
										<div class="col-md-6">
											<table class="product_table">
												<thead style="font-size: medium;">
													<tr>
														<th>Technician Name</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: left;">{{ technician.name }}</td>
													</tr> 
												</thead>
											</table>
										</div>
                                    </div>
								</div>
							    <div class="col-2">
									<router-link to="/technicians" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                                    <!-- <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchTechnicianJobs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="date" class="form-control" v-model="date_filter" @change="fetchTechnicianJobs()" />
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchTechnicianJobs()">
											<option value="">All Job Status</option>
                                            <option value="1">Pending</option>
                                            <option value="2">Ongoing</option>
                                            <option value="3">Completed</option>
                                            <option value="4">Requested</option>
                                            <option value="5">Cancelled</option>
                                            <option value="6">Reassigned</option>
                                            <option value="7">Upcoming</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchTechnicianJobs()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product</th>
											<th>Type</th>
											<th>Date</th>
											<th>Status</th>
											<th>Total Amount</th>
                                            <th>Incentive Earned</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(works.length)">
                                        <tr align="center" v-for="(work, index) in works" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ work.customer_name }}<br>
												+91 {{ work.mobile }}
											</td>
											<td>{{ work.location }}</td>
											<td>{{ work.product_name }}</td>
											<td v-if="work.service_type == 1">New</td>
											<td v-else-if="work.service_type == 2">Repair</td>
											<td v-else>Replacement</td>
											<td>{{ proxy.$filters.convertDate(work.date) }}</td>
											<td>
												<span class="badge rounded-pill bg-info" v-if="work.job_status === 1">Pending</span>
												<span class="badge rounded-pill bg-warning" v-else-if="work.job_status === 2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-else-if="work.job_status === 3">Completed</span>
												<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 4">Requested</span>
												<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 5">Cancelled</span>
												<span class="badge rounded-pill bg-secondary" v-else-if="work.job_status === 6">Reassigned</span>
												<span class="badge rounded-pill bg-warning" v-else-if="work.job_status === 7">Upcoming</span>
											</td>
											<td>Rs.{{ work.total_amount }}</td>
											<td>Rs.{{ work.incentive }}</td>
                                            <td>
												<router-link :to="{ name: 'job_details', query: { id: work.id } }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link><br>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" class="text-center">No works found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchTechnicianJobs(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script setup>
import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { goBack } from '@/utils/urlHider';

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const technician_id = route.query.id;
const keyword = ref("");
const listing_length = ref(10);
const technician = ref({});
const works = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});
const status = ref("");
const date_filter = ref(null);
const fetchTechnicianJobs = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value,
		technician_id: technician_id,
		status: status.value,
		date: date_filter.value || null
	}

	const requestUrl = url ?? routes.TechnicianWorks;

	get(requestUrl, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                works.value = response.data.data.jobs.data;
                technician.value = response.data.data.technician;
				pagination.value = response.data.data.jobs.links;
				from.value = response.data.data.jobs.from;
				to.value = response.data.data.jobs.to;
				total.value = response.data.data.jobs.total;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message.technician_id?.[0] || error.response.data.message.limit?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

onMounted(() => {
	fetchTechnicianJobs();
});

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};

</script>